import { ProductAvailabilityCalendar, InputContainer, AvailabilityLink, Header, CalendarContainer } from './styles'

ProductAvailabilityCalendar.InputContainer = InputContainer
ProductAvailabilityCalendar.AvailabilityLink = AvailabilityLink
ProductAvailabilityCalendar.Header = Header
ProductAvailabilityCalendar.CalendarContainer = CalendarContainer

export default ProductAvailabilityCalendar
